import { render, staticRenderFns } from "./CircleCounter.vue?vue&type=template&id=53d11f8c&"
import script from "./CircleCounter.vue?vue&type=script&lang=js&"
export * from "./CircleCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports